import "./socialicons.css";

const SocialIcons = ({ links, type = "small" }) => {
  // {/* <span className="sidebarTitle">FOLLOW</span> */}
  return (
    <>
      {type === "large" ? (
        <section className="container mt-4 ">
          {/* <h2 className="text-center mb-4 no-text-shadow">Get in Touch</h2> */}
          <div className="row justify-content-center">
            {links &&
              links.map((l) => (
                <ContactCard
                  key={`cc-` + l.id}
                  icon={l.icon}
                  title={l.title}
                  detail={l.handle}
                  link={l.url}
                />
              ))}
          </div>
        </section>
      ) : (
        <div className="sidebarSocial">
          {links &&
            links.map((l) => (
              <a key={`ic-` + l.id} href={l.url}>
                <i className={`sidebarIcon ` + l.icon}></i>
              </a>
            ))}
          {/* {links && (
            <a href={aboutBlog.facebook_url}>
              {" "}
              <i className="sidebarIcon fa-brands fa-square-facebook"></i>
            </a>
          )} */}
        </div>
      )}
    </>
  );
};

const ContactCard = ({ icon, title, detail, link }) => (
  <div className="col-md-6 col-lg-3 col-sm-6 mb-4">
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="card contact-card text-center h-100"
    >
      <div className="card-body">
        <div className="icon mb-3">
          <i className={icon}></i>{" "}
        </div>
        <h5 className="card-title no-text-shadow">{title}</h5>
        <p className="card-text text-muted">{detail}</p>
      </div>
    </a>
  </div>
);

export default SocialIcons;
